/**
 * Mobile menu
 */
var component_mobile_menu = function(args) {

  // setup args
  var menu     = args.menu,
      site     = args.site,
      toggles  = args.toggles;

  // validate
  if (!menu || !site || !toggles.length) {
    console.log('Invalid mobile_menu args');
    return;
  }

  // setup a11y dialog
  var dialog = new A11yDialog(menu, site);

  // tasks to open menu visually
  var open_menu = function() {

   document.body.classList.add('is-active-menu');

  };

  // tasks to close menu visually
  var close_menu = function() {

    document.body.classList.add('is-closing-menu');
    setTimeout(function(){
      document.body.classList.remove('is-active-menu');
      document.body.classList.remove('is-closing-menu');
     }, 200);

  };

  // hooks
  dialog.on('show', function (element, event) {
    open_menu();
  });
  dialog.on('hide', function (element, event) {
    close_menu();
  });


  // toggle click
  var handle_toggle = function(e) {
    if (document.body.classList.contains('is-active-menu')) {
       dialog.hide();
    } else {
      dialog.show();
    }
  };

  for (var i = 0; i < toggles.length; i++) {
    toggles[i].addEventListener('click', handle_toggle, false);
  }
  auto_open_sub_menus(menu);
  // make the call chainable
  return this;

};
var open_parents = function(menu_item) {

  var parent_sub_menu = menu_item.parentNode;
  var parent = parent_sub_menu.parentNode;

  if(parent.classList.contains('menu-item')) {
    parent.setAttribute('aria-expanded', true);
    parent_sub_menu.setAttribute('aria-hidden', false);
    if(parent.parentNode.parentNode.classList.contains('menu-item')) {
      open_parents(parent);
    }
  }
}
var open_sub_menu = function(menu_item) {
  var sub_menu = menu_item.querySelector('.sub-menu');
  if(sub_menu != null) {
    menu_item.setAttribute('aria-expanded', true);
    sub_menu.setAttribute('aria-hidden', false);
  }
}

var auto_open_sub_menus = function(menu) {
  var current_menu_item = menu.querySelector('.current-menu-item');
  if(current_menu_item != null) {
    open_parents(current_menu_item);
    open_sub_menu(current_menu_item);
  }
};
